import template from './page.audit-trial.html';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.document.paged-document.audit-trial',
    []
  )
  .component('tcAuditTrial', {
    //tc-audit-trial
    template,
    bindings: {
      me: '<',
      document: '<',
    },
    controller: function () {},
  }).name;
